<template>
    <div class="container">
        <div class="page-title">Оформление заказа</div>
        <div class="section checkout">
            <div class="checkout-section_form">
                <checkout-form></checkout-form>
            </div>
            <div class="checkout-section_order">
                <div class="checkout-section_order-block">
                    <checkout-card></checkout-card>
                    <checkout-card></checkout-card>
                    <checkout-card></checkout-card>
                    <checkout-card></checkout-card>
                    <checkout-card></checkout-card>
                    <div class="checkout-section_order-block_total">
                        <div class="delivery">
                            <span class="title">Доставка:</span>
                            <span class="price">40</span>
                            <span class="currency">грн.</span>
                        </div>
                        <div class="total">
                            <span class="title">Всего:</span>
                            <span class="price">35 543</span>
                            <span class="currency">грн.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CheckoutCard from '../components/Cards/CheckoutCard';
    import CheckoutForm from '../components/Forms/CheckoutForm';
    export default {
        name: "Checkout",
        components: { CheckoutCard, CheckoutForm }
    };
</script>

<style scoped lang="scss">
    .checkout {
        display: flex;
        width: 100%;
        &-section {
            &_form {
                width: 100%;
                max-width: 488px
            }
            &_order {
                width: 100%;
                max-width: 695px;
                margin-left: 32px;
                &-block {
                    background: #FCFCFC;
                    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05);
                    border-radius: 5px;
                    margin-top: 37px;
                    > div {
                        &:not(:last-child) {
                            border-bottom: 1px solid #EDF0F2;
                        }
                    }
                    &_total {
                        padding: 24px;
                        .delivery {
                            .title {
                                color: #3F4450;
                                font-size: 16px;
                                line-height: 25px;
                                width: 80px;
                            }
                            .price {
                                margin-left: 24px;
                            }
                            .price, .currency {
                                color: #3F4450;
                                font-size: 16px;
                                line-height: 25px;
                            }
                        }
                        .total {
                            .title {
                                color: #3F4450;
                                font-size: 22px;
                                line-height: 34px;
                                width: 80px;
                            }
                            .price {
                                color: #3FB0AB;
                                font-size: 22px;
                                line-height: 34px;
                                margin-left: 24px;

                            }
                            .currency {
                                color: #3FB0AB;
                                font-size: 14px;
                                line-height: 21px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
